import Vue from 'vue';
import App from './App.vue';
import LogRocket from 'logrocket';
import * as Sentry from '@sentry/vue';

Sentry.init({
  Vue,
  dsn:
    process.env.NODE_ENV === 'production'
      ? 'https://304859c9ea524ad1a596d7bd7c38ccb3@sentry.oustatic.com/95'
      : 'https://d920c1accc814df9b83699e02da25bac@sentry.oudev.org/186',
  attachProps: true,
  logErrors: true,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
  environment: process.env.NODE_ENV
});

LogRocket.init('orthodox-union/jfe-signup');
LogRocket.getSessionURL((sessionURL) => {
  Sentry.configureScope((scope) => {
    scope.setExtra('sessionURL', sessionURL);
  });
});

Vue.config.productionTip = false;
Vue.config.ignoredElements = [
  'jfe-form',
  'confirm-account',
  'change-password',
  'forgot-password',
  'log-in',
  'migration'
];

const AppComponent = Vue.extend({
  render(h) {
    return h(App);
  }
});

// tslint:disable-next-line
new AppComponent().$mount('#app');
